import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Container } from "@material-ui/core";
import NavBar from "./NavBar";
import SideMenu from "./SideMenu";
import Dashboard from "./Dashboard";
import SettingsPage from "./SettingsPage";
import TruckRoute from "./TruckRoute";
import { UserDataContext } from "../Contexts/UserDataContext";
import { makeStyles } from "@material-ui/core/styles";
import InvoicePage from "./InvoicePage";
import WeeklyAuditPage from "./WeeklyAuditPage";
import InvoiceAuditPage from "./InvoiceAuditPage";
import LclDataContextProvider from "../Contexts/LclDataContext";
import ParcelDataContextProvider from "../Contexts/ParcelDataContext";
import HourlyDataContextProvider from "../Contexts/HourlyDataContext";
import LinehaulFixedDataContextProvider from "../Contexts/LinehaulFixedDataContext";
import LinehaulFloatingDataContextProvider from "../Contexts/LinehaulFloatingDataContext";
import MasterDataPage from "./MasterData/MasterDataPage";
import ChangePasswordForm from "./ChangePasswordForm";
import { useIdleTimer } from "react-idle-timer";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    marginTop: theme.spacing(4),
  },
}));

const PageRoute = () => {
  const classes = useStyles();
  const { userData, logout } = useContext(UserDataContext);

  console.log("page route render");

  useIdleTimer({
    timeout: 1000 * 60 * 30, // in miliseconds - 30 minutes
    // timeout: 1000 * 60, // in miliseconds - 1 minute (test only)
    // timeout: 1000 * 20, // in miliseconds - 20 seconds (test only)
    onIdle: logout,
  });

  return (
    <>
      {userData.resetPassword && (
        <Container maxWidth="lg" className={classes.pageContainer}>
          <ChangePasswordForm />
        </Container>
      )}

      {userData.resetPassword !== undefined && !userData.resetPassword && (
        <>
          <SideMenu />
          <NavBar />
          <LclDataContextProvider>
            <ParcelDataContextProvider>
              <HourlyDataContextProvider>
                <LinehaulFixedDataContextProvider>
                  <LinehaulFloatingDataContextProvider>
                    <Container maxWidth="lg" className={classes.pageContainer}>
                      <Switch>
                        <Route
                          path={`/${userData.userName}/dashboard`}
                          component={() => <Dashboard />}
                          exact
                        />
                        <Route
                          path={`/${userData.userName}/settings`}
                          component={() => <SettingsPage />}
                          exact
                        />
                        <Route
                          path={`/${userData.userName}/trucks`}
                          component={() => <TruckRoute />}
                        />
                        <Route
                          path={`/${userData.userName}/invoices`}
                          component={() => <InvoicePage />}
                          exact
                        />
                        <Route
                          path={`/${userData.userName}/weekly-audit`}
                          component={WeeklyAuditPage}
                          exact
                        />
                        <Route
                          path={`/${userData.userName}/invoice-audit`}
                          component={InvoiceAuditPage}
                          exact
                        />
                        <Route
                          path={`/${userData.userName}/master-data`}
                          component={MasterDataPage}
                          exact
                        />
                        <Redirect
                          from="/"
                          to={`/${userData.userName}/dashboard/`}
                        />
                      </Switch>
                    </Container>
                  </LinehaulFloatingDataContextProvider>
                </LinehaulFixedDataContextProvider>
              </HourlyDataContextProvider>
            </ParcelDataContextProvider>
          </LclDataContextProvider>
        </>
      )}
    </>
  );
};

export default PageRoute;
